/**
 * AR Vision Demo — workflow build-animation signal.
 *
 * THROWAWAY DEMO CODE. Bridges the scripted create/amend tools (scenes 5 + 9)
 * and the staggered build animation on the demo workflow canvas so Nami's
 * "Done…" narration only streams AFTER the boxes finish animating in.
 *
 * Flow: the tool calls `awaitNextWorkflowBuild()` (getting a promise) right
 * before it flips the fixture state + navigates; `DemoWorkflowPage` calls
 * `signalWorkflowBuildComplete()` once its reveal animation settles, resolving
 * that promise. A safety timeout guarantees the promise always resolves so the
 * narration can never hang. Delete alongside frontend/src/demo/ar.
 */

let resolveCurrent: (() => void) | null = null;

/**
 * Arm a fresh build and return a promise that resolves when the canvas reports
 * the build animation finished (or after `maxMs` as a safety net).
 */
export function awaitNextWorkflowBuild(maxMs = 6000): Promise<void> {
  return new Promise<void>((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolveCurrent = null;
      resolve();
    };
    resolveCurrent = finish;
    setTimeout(finish, maxMs);
  });
}

/** Called by the workflow canvas once the staggered reveal has settled. */
export function signalWorkflowBuildComplete(): void {
  resolveCurrent?.();
}
